var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", { staticClass: "visitor-step-2 visitor-step-2-theme" }, [
    _c("div", { staticClass: "visitor-step-2-inner" }, [
      _c("div", { staticClass: "visitor-step-2-img-wrapper" }, [
        _c("img", {
          staticClass: "visitor-step-2-img",
          attrs: { src: _vm.visitorImage, alt: "paper-plane-image" },
        }),
      ]),
      _vm._v(" "),
      _c("p", {
        staticClass: "visitor-step-2-desc check-the-email",
        domProps: { innerHTML: _vm._s(_vm.$t("visitorCheckTheEmail")) },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }